import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { Instagram, Mail, MessageCircle } from "lucide-react";

export default function Footer() {
  const { settings } = useSettings();
  const wa = (settings.socials?.whatsapp || "").replace(/\D/g, "");
  const email = settings.socials?.email || "";
  const insta = settings.socials?.instagram || "";
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-[color:var(--border)] bg-[color:var(--bg)]">
      <div className="max-w-[1500px] mx-auto px-5 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            {settings.logo_url ? (
              <img src={settings.logo_url} alt={settings.brand_name} className="h-10 mb-4" />
            ) : (
              <div className="font-display italic text-3xl md:text-4xl leading-tight">{settings.brand_name}</div>
            )}
            <p className="mt-4 text-[color:var(--text-muted)] max-w-sm text-sm leading-relaxed">
              {settings.subtagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow mb-3">Locations</div>
            <ul className="flex flex-col gap-2 text-sm text-[color:var(--text)]">
              {(settings.locations_served || []).map((l) => (
                <li key={l} data-testid={`footer-loc-${l.toLowerCase()}`}>{l}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="eyebrow mb-3">Contact</div>
            <div className="flex flex-col gap-3">
              {wa && (
                <a data-testid="footer-whatsapp" href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm link-underline w-fit">
                  <MessageCircle size={16} /> WhatsApp
                </a>
              )}
              {insta && (
                <a data-testid="footer-instagram" href={insta} target="_blank" rel="noreferrer" className="flex items-center gap-3 text-sm link-underline w-fit">
                  <Instagram size={16} /> Instagram
                </a>
              )}
              {email && (
                <a data-testid="footer-email" href={`mailto:${email}`} className="flex items-center gap-3 text-sm link-underline w-fit">
                  <Mail size={16} /> {email}
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[color:var(--border)] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="text-xs text-[color:var(--text-muted)]">{settings.footer_copy}</div>
          <Link to="/admin/login" data-testid="footer-admin-link" className="eyebrow text-[color:var(--text-muted)] hover:text-[color:var(--accent)]">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
